import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: 'full',
            marginY: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            minHeight: {base: remCalc(576), sm: remCalc(460), md: remCalc(548), lg: remCalc(1024)},
            flexDirection: {base: 'column', lg: 'row'},
            justify: 'space-between',
            align: 'center',
            gap: 0,
            transition: 'all 0.5s ease-in-out',
        },
        addIcon: {
            color: 'background.default',
            boxSize: {base: 'iconsSize.large', lg: 'iconsSize.xlarge'},
        },
        subtitle: {
            color: 'text.inverse',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            textTransform: 'uppercase',
        },
        text: {
            color: 'text.inverse',
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        title: {
            color: 'text.inverse',
            textStyle: 'head-medium',
            fontWeight: 'medium',
        },
        card: {
            gap: remCalc(24),
            alignItems: 'center',
            flex: 1,
            w: {base: '100%', lg: 'auto'},
            flexDirection: {base: 'row', lg: 'column'},
        },
        cardContainer: {
            w: {base: '100%', lg: 'auto'},
            borderStyle: 'solid',
            borderColor: {base: 'text.inverse', lg: 'text.inverse'},
            transition: 'all 0.5s ease-in-out',
            justifyContent: 'center',
            position: 'relative',
            h: '100%',
            _hover: {
                backgroundColor: 'rgba(0, 0, 0, 0.50)',
            },
        },
        closeIcon: {
            color: 'text.inverse',
            boxSize: {lg: 'iconsSize.large', xl: 'iconsSize.xlarge'},
            position: 'absolute',
            top: {
                base: remCalc(24),
                md: remCalc(24),
                lg: remCalc(24),
                xl: remCalc(40),
            },
            right: {
                base: remCalc(16),
                md: remCalc(24),
                lg: remCalc(24),
                xl: remCalc(24),
            },
        },
        closeIconMobile: {
            color: 'text.inverse',
            boxSize: {base: 'iconsSize.medium', md: 'iconsSize.large'},
        },
        chevronRight: {
            boxSize: 'iconsSize.medium',
        },
        selectedCard: {
            alignItems: 'start',
            gap: {base: remCalc(16), md: remCalc(8), lg: remCalc(24)},
        },
        mobileCard: {
            w: '100%',
            justifyContent: 'space-between',
        },
        selectedContainer: {
            display: 'flex',
            flexDirection: {base: 'column', lg: 'row'},
            transition: 'all 0.0001s',
        },
        mobileSelectedContainer: {
            gap: remCalc(16),
            justifyContent: 'space-between',
        },
        mobileClosedCard: {
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        fullContainer: {
            w: '100%',
        },
        buttonVariant: {
            variant: 'inverse-icon-button',
        },
    },
}
